import { subDays } from 'date-fns';
import { LAST_ONE_MONTH, PAST_PICKUPS_GRID_FILTERS } from './Constants';

const getPickupStatus = (pickup) => {
  if (pickup.isVoided) {
    return PAST_PICKUPS_GRID_FILTERS.voided;
  } else if (pickup.isNoFreight) {
    return PAST_PICKUPS_GRID_FILTERS.noFreight;
  } else if (pickup.isCompleted) {
    return PAST_PICKUPS_GRID_FILTERS.completed;
  }
  return PAST_PICKUPS_GRID_FILTERS.completed;
};

const getFieldError = (field, value) => {
  if (field === 'selectedDateRange') {
    return getDateRangeError(value);
  }
  return null;
};

const getDateRangeError = (date) => {
  if (!date[0].startDate || !date[0].endDate) {
    return '* Required';
  }
  return null;
};

const filterPickup = ({ pickup, pickupFilter }) => {
  return pickupFilter?.filterFunc?.({
    pickup
  });
};

const getDefaultDateRange = (startDate, endDate) => {
  return [
    {
      startDate: startDate ? new Date(startDate) : subDays(new Date(), LAST_ONE_MONTH + 1),
      endDate: endDate ? new Date(endDate) : subDays(new Date(), 1),
      key: 'selection'
    }
  ];
};

export { getPickupStatus, getFieldError, getDateRangeError, filterPickup, getDefaultDateRange };
